import { Component, Input, OnInit } from "@angular/core"
import { ActivatedRoute, NavigationExtras, Params, Router } from "@angular/router"
import { BrowsingService } from "../../../services/browsing.service"
import { LabeledValue } from "../../../utils/types"
import { EduComponent } from "../../../utils/eduComponent"
import { fadeInXY, rotateRight, routeAnimations } from "../../../utils/animations"

@Component({
    selector: "app-rank-by",
    templateUrl: "./rank-by.component.html",
    styleUrls: ["./rank-by.component.scss"],
    animations: [fadeInXY],
    standalone: false,
})
export class RankByComponent extends EduComponent implements OnInit {
    rankBy: string = "relevance"
    type: string = "search"

    sortByOptions: Array<LabeledValue>
    selectedOption

    @Input() isOnSearch?: boolean = false

    constructor(
        private browsingService: BrowsingService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        super()
    }

    ngOnInit() {
        this.sortByOptions = this.browsingService.sortByOptions
        this.addSub(
            this.route.queryParams.subscribe((queryParams: Params) => {
                if (queryParams.hasOwnProperty("rank_by")) {
                    if (
                        this.sortByOptions
                            .map((obj) => obj.value)
                            .filter((value) => value === queryParams["rank_by"]).length > 0
                    ) {
                        this.rankBy = queryParams["rank_by"]
                    } else {
                        // Based on sentry issues and DSU discussion on 24 Feb 2025
                        // we are going to default on recency when the ranking key is invalid
                        // Sentry Issue: https://pbs-64.sentry.io/issues/4013489056/events/42c01feca0d943a8af7cda019d52a3b5/
                        this.rankBy = "recency"
                    }
                } // default is relevance
                this.checkContext()
            })
        )
    }

    checkContext() {
        if (this.router.url.includes("search")) {
            this.type = "search"
        } else if (this.router.url.includes("subjects")) {
            this.type = "browse"
        } else if (this.router.url.includes("grades")) {
            this.type = "browse-by-grade"
        }
        const maybeSelectedOptionObject = this.sortByOptions.find(
            (opt) => opt.value === this.rankBy
        )
        if (maybeSelectedOptionObject) {
            this.selectedOption = maybeSelectedOptionObject.value
        } else {
            console.error("unknown sort option", this.rankBy)
        }
    }

    changeRanking(option: string) {
        this.rankBy = option
        let extras: NavigationExtras = {
            queryParams: { rank_by: this.rankBy },
            queryParamsHandling: "merge",
            relativeTo: this.route,
        }
        this.router.navigate(["."], extras)
    }
}
